// Version : 0.0.1
// Author : VISHAL BHARATHI
// CREATED DATA: 18-09-2025

import TransferFunderActionTypes from './transfer-funder.types';

/** ***************** UPDATE TRANSFER FUNDER DETAILS START *********************** */
export const updateTransferFunderDetailsStart = (getData: any) => ({
	type: TransferFunderActionTypes.UPDATE_TRANSFER_FUNDER_DETAILS_START,
	payload: getData,
});

export const updateTransferFunderDetailsSuccess = (successData: any) => ({
	type: TransferFunderActionTypes.UPDATE_TRANSFER_FUNDER_DETAILS_SUCCESS,
	payload: successData,
});

export const updateTransferFunderDetailsFailure = (failureData: any) => ({
	type: TransferFunderActionTypes.UPDATE_TRANSFER_FUNDER_DETAILS_FAILURE,
	payload: failureData,
});

export const updateTransferFunderDetailsResponseResetStart = () => ({
	type: TransferFunderActionTypes.UPDATE_TRANSFER_FUNDER_DETAILS_RESPONSE_RESET,
});

export const updateTransferFunderDetailsResponseChanged = () => ({
	type: TransferFunderActionTypes.UPDATE_TRANSFER_FUNDER_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE TRANSFER FUNDER DETAILS END *********************** */

/** ***************** FETCH ALL LOAN INDEX LIST FOR GROUP START *********************** */
export const fetchAllLoanIndexListForGroupStart = (getData: any) => ({
	type: TransferFunderActionTypes.FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_START,
	payload: getData,
});

export const fetchAllLoanIndexListForGroupSuccess = (successData: any) => ({
	type: TransferFunderActionTypes.FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_SUCCESS,
	payload: successData,
});

export const fetchAllLoanIndexListForGroupFailure = (failureData: any) => ({
	type: TransferFunderActionTypes.FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_FAILURE,
	payload: failureData,
});

export const fetchAllLoanIndexListForGroupResponseResetStart = () => ({
	type: TransferFunderActionTypes.FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_RESPONSE_RESET,
});

export const fetchAllLoanIndexListForGroupResponseChanged = () => ({
	type: TransferFunderActionTypes.FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL LOAN INDEX LIST FOR GROUP END *********************** */
